import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "user-center"
};
const _hoisted_2 = {
  class: "main-wrap user-wrap"
};
const _hoisted_3 = {
  class: "user-main-wrap"
};
const _hoisted_4 = {
  class: "user-header"
};
const _hoisted_5 = {
  class: "user-bc"
};
const _hoisted_6 = {
  class: "name"
};
const _hoisted_7 = {
  class: "mobile"
};
const _hoisted_8 = {
  key: 0,
  class: "welfare"
};
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"welfare-item\"><div class=\"value\">0</div><div class=\"name\">卡券</div></div><div class=\"welfare-item\"><div class=\"value\">0</div><div class=\"name\">积分</div></div>", 2);
const _hoisted_11 = [_hoisted_9];
const _hoisted_12 = {
  class: "card user-card journey"
};
const _hoisted_13 = {
  class: "card user-card"
};
const _hoisted_14 = {
  key: 1,
  class: "user-bottom-wrap"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "copyright"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "©2025 杭州金桔子科技有限公司")], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_tag = _resolveComponent("van-tag");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_grid_item = _resolveComponent("van-grid-item");
  const _component_van_grid = _resolveComponent("van-grid");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_nav_bar, {
    class: "user-nav-bar",
    title: $setup.title,
    border: false
  }, null, 8, ["title"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_image, {
    round: "",
    src: $setup.userAvatar
  }, null, 8, ["src"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($setup.userData ? $setup.userData.nick_name : '匿名'), 1), _createElementVNode("div", _hoisted_7, _toDisplayString($setup.userData ? $setup.userData.phone_number.substr(0, 3) + '****' + $setup.userData.phone_number.substr(7, 4) : '--'), 1)]), false ? (_openBlock(), _createBlock(_component_van_tag, {
    key: 0,
    class: "level lv1",
    round: "",
    type: "primary",
    onClick: $options.goVIP
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "gem-o"
    }), _createTextVNode(" 普卡 ")]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]), false ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_cell, {
    title: "我的行程",
    value: "全部行程",
    border: true,
    "is-link": "",
    onClick: $options.goOrders
  }, null, 8, ["onClick"]), _createVNode(_component_van_grid, {
    border: false,
    "column-num": 2
  }, {
    default: _withCtx(() => [_createVNode(_component_van_grid_item, {
      icon: "todo-list-o",
      text: "行程中",
      onClick: $options.goProgress
    }, null, 8, ["onClick"]), _createVNode(_component_van_grid_item, {
      icon: "after-sale",
      text: "待付款",
      onClick: $options.goWaitPay
    }, null, 8, ["onClick"]), false ? (_openBlock(), _createBlock(_component_van_grid_item, {
      key: 0,
      icon: "comment-o",
      text: "待评价",
      onClick: $options.goWaitEvaluate
    }, null, 8, ["onClick"])) : _createCommentVNode("", true), false ? (_openBlock(), _createBlock(_component_van_grid_item, {
      key: 1,
      icon: "phone-circle-o",
      text: "语音单",
      onClick: $options.goVoice
    }, null, 8, ["onClick"])) : _createCommentVNode("", true)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_13, [false ? (_openBlock(), _createBlock(_component_van_cell, {
    key: 0,
    icon: "service-o",
    title: "帮助和支持",
    "is-link": ""
  })) : _createCommentVNode("", true), false ? (_openBlock(), _createBlock(_component_van_cell, {
    key: 1,
    icon: "point-gift-o",
    title: "推荐给好友",
    "is-link": ""
  })) : _createCommentVNode("", true), _createVNode(_component_van_cell, {
    icon: "warning-o",
    title: "系统版本",
    value: $options.Config.versionName
  }, null, 8, ["value"])]), !$options.StorageUtil().get('weChatModel') ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_van_button, {
    class: "logout-button",
    block: "",
    onClick: $options.logout
  }, {
    default: _withCtx(() => [_createTextVNode(" 退出登录 ")]),
    _: 1
  }, 8, ["onClick"]), _hoisted_15])) : _createCommentVNode("", true)])])]);
}